import React, { useState, useEffect } from 'react';
import { handleException } from "../../app/util/util";
import { useSelector, useDispatch } from 'react-redux';
import CustomNoteContainer from './CustomNoteContainer';
import { setCustomOutlineTitle } from '../../app/redux/UserSlice';
function NotesTabContainer(props) {
    const dispatch = useDispatch();
    const { userVO } = props;
    const currUserVO = useSelector((s) => s.userVO);
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const handleSetCustomOutlineTitle = (OutlineTitle) => dispatch(setCustomOutlineTitle(OutlineTitle));
    const [customOutlineId, setCustomOutlineId] = useState("");
    const [customNoteTitle, setCustomNoteTitle] = useState("");
    const [customOutlineVOList, setCustomOutlineVOList] = useState([]);
    useEffect(() => {
        if (currUserVO.customOutlineTitle) { setCustomOutlineVOList(currUserVO.customOutlineTitle); }
    }, [currUserVO.customOutlineTitle]);
    useEffect(() => { getCustomeOutline(); }, []);
    const getCustomeOutline = () => {
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadChapterId": "",
                    "lastViewedOutlineId": "",
                    "pageNavigatingTo": "EReader",
                    "lastReadParagraphId": "para01",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "lastReadSubSectionId": "subsec01",
                    "lastReadBookId": props.bookVO.bookId,
                    "lastViewedOutlineType": "chapterOutline"
                },
                "sessionVO": {
                    "appType": "web",
                    "deviceMacId": "",
                    "keepMeLoggedInFlag": keepMeLogIn,
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceType": localStorage.getItem('deviceType'),
                    "browserName": localStorage.getItem('browserName'),
                    "sessionAuthenticationToken": userVO.sessionAuthenticationToken
                }
            },
            "outlineVO": {
                "bookId": props.bookVO.bookId,
                "recentNotesFlag": "customOutline"
            }
        }
        const requestOptions1 = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/manageOutlineService/getOutlineNotes`, requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data && data.status === "true") {
                    let currentCustomOutlineVOList = [];
                    if (data.outlineVO !== null && data.outlineVO.customOutlineVO !== undefined) {
                        currentCustomOutlineVOList = Array.isArray(data.outlineVO.customOutlineVO) ? data.outlineVO.customOutlineVO : [data.outlineVO.customOutlineVO]
                        let i = Object.create(currentCustomOutlineVOList);
                        i.chapterId = '-999'; i.chapterTitle = '';
                        i.lastModifiedTimestamp = ''; i.outlineType = '';
                        currentCustomOutlineVOList.unshift(i);
                        handleSetCustomOutlineTitle(currentCustomOutlineVOList);
                        setCustomOutlineVOList(currUserVO.customOutlineTitle);
                        setCustomOutlineId(""); setCustomNoteTitle("");
                    }
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const onChangeCustomOutlineEvent = (e) => {
        if (e.nativeEvent.target[e.nativeEvent.target.selectedIndex].attributes != undefined && e.nativeEvent.target[e.nativeEvent.target.selectedIndex].attributes.length != 0) {
            let customNoteTitle = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].attributes["customNoteTitle"].value
            setCustomOutlineId(e.target.value); setCustomNoteTitle(customNoteTitle);
        }
    }
    const onAddCustomNote = (id, title) => {
        setCustomOutlineId(id); setCustomNoteTitle(title);
        document.querySelector("#customOutlineDropDown").value = id;
    }
    return (
        <div className="casesList iPadMargin">
            <div className="display-inline-block viewingPort_rt mTopTen">
                {/* 47052 - A11Y: Viewing select box does not have a label */}
                {/* Original: <div className="display-inline-block viewingLabel_rt">Viewing</div> */}
                <label className="display-inline-block viewingLabel_rt" htmlFor="customOutlineDropDown">Viewing</label>
                <select data-testid="select_chapter" id="customOutlineDropDown" className="viewingInput_rt mLeftFive form-control text-box-common display-inline-block"
                    onChange={onChangeCustomOutlineEvent} >
                    {customOutlineVOList !== undefined ? customOutlineVOList.map((option) => (
                        <option customNoteTitle={option.chapterTitle} value={option.chapterId}>{option.chapterTitle}</option>
                    )) : ""}
                </select>
            </div>
            <div className="mTopTen chapterTitle_rt"></div>
            <CustomNoteContainer bookVO={props.bookVO} userVO={props.userVO}
                customOutlineId={customOutlineId} customNoteTitle={customNoteTitle} onAddCustomOuline={onAddCustomNote} />
        </div>
    )
}
export default (NotesTabContainer);